import { useAppShellStoreActions } from "PFApp/stores/app_shell_store";
import { Icon } from "PFComponents/icon";
import { ProfindaLogo } from "PFComponents/profinda_logo";
import { fullMarkdown } from "PFCore/helpers/markdown";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";

import css from "./footer.module.scss";

const Footer = ({ style }) => {
  const linksRef = useRef();

  const { showTerms } = useAppShellStoreActions();

  const { data: currentAccount } = useCurrentAccount();

  const handleLinkClick = (e) => {
    const href = e.target.getAttribute("href");
    if (href === "/terms") {
      e.preventDefault();
      showTerms();
    }
  };

  useEffect(() => {
    linksRef.current && linksRef.current.addEventListener("click", handleLinkClick);
    return () => {
      linksRef.current && linksRef.current.removeEventListener("click", handleLinkClick);
    };
  }, [linksRef.current]);

  const { customization } = currentAccount;

  if (!customization) {
    return null;
  }

  const { showFooterLogo, copyright, facebookUrl, twitterUrl, instagramUrl, linkedinUrl } = customization;
  const footerLinks = fullMarkdown(customization.footerLinks);

  return (
    <div className={css.root} style={style}>
      <div className={css.logo}>
        {showFooterLogo && <ProfindaLogo width={75} colorMain="#fff" colorSecondary="#fff" />}
      </div>

      {copyright && (
        <span className={css.legal}>
          {copyright} {new Date().getFullYear()}
        </span>
      )}

      <div className={css.social}>
        {linkedinUrl && (
          <a href={linkedinUrl} target="_blank" rel="noopener noreferrer">
            <Icon name="linkedin" />
          </a>
        )}

        {facebookUrl && (
          <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
            <Icon name="facebook" />
          </a>
        )}

        {twitterUrl && (
          <a href={twitterUrl} target="_blank" rel="noopener noreferrer">
            <Icon name="twitter" />
          </a>
        )}

        {instagramUrl && (
          <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
            <Icon name="instagram" />
          </a>
        )}
      </div>

      {footerLinks && (
        <div ref={linksRef} className={css.links} dangerouslySetInnerHTML={{ __html: footerLinks }} />
      )}
    </div>
  );
};

Footer.propTypes = {
  style: PropTypes.object
};

export default Footer;
